import { Component, createElement } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 300,
    fontSize: 24 * 0.65,
    border: 0,
    margin: 0,
    display: 'inline-block',
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    background: '#636363',
    color: '#ffffff',
    cursor: 'pointer',
    borderRadius: 3,
    '&:hover, &:focus': {
    },
    '&:focus': {
      outline: 'none'
    },
  },
  square: {
    border: '1px solid currentColor',
    padding: `${10 * 0.65}px ${20 * 0.65}px`,
    background: 'none',
    color: '#565759',
    borderRadius: 0,
    '&:hover, &:focus': {
      textDecoration: 'none',
    },
  },
  round: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid currentColor',
    minWidth: 70 * 0.65,
    height: 70 * 0.65,
    textAlign: 'center',
    borderRadius: 35,
    padding: 15 * 0.65,
    background: 'none',
    color: '#565759',
    '&:hover, &:focus': {
      textDecoration: 'none',
    },
  },
  text: {
    background: 'none',
    color: '#565759',
  },
  underline: {
    textDecoration: 'underline'
  },
})

export default
@withStyles(styles)
class OnboardingStepButton extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    component: PropTypes.any,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    square: PropTypes.bool,
    round: PropTypes.bool,
    className: PropTypes.any,
    underline: PropTypes.bool,
    text: PropTypes.bool,
  }

  static defaultProps = {
    component: 'button',
    onClick: () => {},
  }

  handleClick = (ev) => {
    const { onClick, disabled } = this.props
    if (disabled) {
      ev.preventDefault()
    } else {
      onClick(ev)
    }
  }

  render() {
    const { component, classes, square, round, underline, className, text, ...rest } = this.props
    const cx = classNames(className, classes.root, {
      [classes.square]: square,
      [classes.round]: round,
      [classes.text]: text,
      [classes.underline]: underline,
    })
    return createElement(component, {
      ...rest,
      className: cx,
      onClick: this.handleClick,
      type: component === 'button' ? 'button' : undefined,
    })
  }
}
